import '../../scss/hp.scss'
import { RegulierAutopromo } from '../../components/regulier-autopromo/regulier-autopromo.jsx'
import { Event } from '../../components/event/event.jsx'
import { OccasionnelAutopromo } from '../../components/occasionnel-autopromo/occasionnel-autopromo.jsx'
import { OccasionnelONews } from '../../components/occasionnel-onews/occasionnel-onews.jsx'
import { SSEInit } from '../dataProvider/SSEManager.js'
import { renderAdvise } from '../componentsOrchestrator/renderAdviseOrchestrator.js'
import { accessibility } from '../modules/accessibility.js'
import { SG1Logs } from '../modules/logs.js'
import { makeSSEInterface } from '../modules/utilities.js'
import { carrouselOrchestrator } from '../componentsOrchestrator/carrouselOrchestrator.js'
import { genericOrchestrator } from '../componentsOrchestrator/genericOrchestrator.js'
import { metadataOrchestrator } from '../componentsOrchestrator/metadataOrchestrator.js'
import { newsOrchestrator } from '../componentsOrchestrator/newsOrchestrator.js'
import { newsMobileOrchestrator } from '../componentsOrchestrator/newsMobileOrchestrator.js'
import { orangeInsideOrchestrator } from '../componentsOrchestrator/orangeInsideOrchestrator.js'
import { secondContractOrchestrator } from '../componentsOrchestrator/secondContractOrchestrator.js'
import { initOnewsProspect } from '../componentsOrchestrator/newsOrchestrator.js'

try {

   SG1Logs.init()

   // DOM data Orchestration ============================
   newsOrchestrator(makeSSEInterface('news', 'dom', window.dataStoreHP.bandes.news))
   document.addEventListener('sseEndOfTransmition', () => {
      try {
         let segment = window.dataStoreHP.pageId
         let device = window.dataStoreHP.device
         genericOrchestrator(makeSSEInterface('jo2024', 'dom', ''))

         if (device !== 'mobile') {
            orangeInsideOrchestrator()
         }

         if (segment === 'hp-prospect') {
            if (device === 'mobile') {
               newsMobileOrchestrator()
            } else {
               initOnewsProspect()
            }
         }
         accessibility()
      } catch (error) {
         console.error('HP orchestrator', error)
         SG1Logs.incLog('Err_PORCH')
         SG1Logs.sentryEvent({ error: error, name: 'Page Orchestrator' })
      }
   })

   // SSE Orchestration ============================
   let resolveGetAdviseSSE
   let getAdviseSSE
   getAdviseSSE = new Promise((resolve, reject) => {
      resolveGetAdviseSSE = resolve
   })

   const specificOrchestratorHandler = {
      carrousel: carrouselOrchestrator,
      metaData: metadataOrchestrator,
      secondContract: secondContractOrchestrator(getAdviseSSE),
   }

   SSEInit('portail_events', specificOrchestratorHandler, resolveGetAdviseSSE)

   // Advise Orchestration ============================
   const adviseTemplates = {
      regulierAutopromo: RegulierAutopromo,
      event: Event,
      occasionnelAutopromo: OccasionnelAutopromo,
      occasionnelONews: OccasionnelONews,
   }

   getAdviseSSE.then((result) => {
      let segment = window.dataStoreHP.pageId
      if (segment === 'hp-occasionnel') {
         newsOrchestrator(makeSSEInterface('news', 'advise', result.reducedDatas))
      }
      renderAdvise(adviseTemplates, result.reducedDatas) // Rendu standard
   })
} catch (error) {
   console.error('HP orchestrator', error)
   SG1Logs.incLog('Err_PORCH')
   SG1Logs.sentryEvent({ error: error, name: 'Page Orchestrator' })
}
